import { Component } from '@theme/component';

/**
 * Bundle-savings ladder "add one more" button.
 *
 * The ladder itself is server-rendered in `cart-summary.liquid` and recomputes
 * on every cart morph, so this component only handles the add action. It proxies
 * a click to the first cart line's quantity "+" button so the add flows through
 * the sanctioned `cart-items-component` mutation queue (morph + error handling +
 * line-key regeneration) — never a hand-rolled `/cart/change`.
 *
 * @extends {Component}
 */
class CartLadderComponent extends Component {
  /** @type {number | undefined} */
  #spinTimer;

  /**
   * Shows the loading spinner on THIS instance's "+ Add 1" button until the cart
   * morph replaces it (which clears the spinner). A failsafe clears it if the
   * mutation never settles into a morph.
   */
  #showSpinner() {
    const btn = this.querySelector('.cart-ladder__add');
    if (!(btn instanceof HTMLElement)) return;
    btn.setAttribute('data-loading', 'true');
    btn.setAttribute('aria-busy', 'true');
    clearTimeout(this.#spinTimer);
    this.#spinTimer = window.setTimeout(() => {
      btn.removeAttribute('data-loading');
      btn.removeAttribute('aria-busy');
    }, 8000);
  }

  addOne() {
    const scope = this.closest('cart-items-component') ?? document;
    const plus = scope.querySelector('.cart-items__table-row .quantity-plus:not([disabled])');
    if (!(plus instanceof HTMLElement)) return;
    this.#showSpinner();
    plus.click();
  }
}

if (!customElements.get('cart-ladder-component')) {
  customElements.define('cart-ladder-component', CartLadderComponent);
}
